import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  IEvaluateCategoryKeys,
  evaluateCategoryHashWithAll,
  IPosNegKey,
} from "../../../const";
import useReviewsData from "../../../repository/useReviews";
import useBID from "../../../utils/useBid";

const useReviewPage = () => {
  const bId = useBID();

  const [searchParams, setSearchParams] = useSearchParams();

  // 18 + 総合評価
  const categoryIdxInit =
    (searchParams.get("category") as IEvaluateCategoryKeys | null) || "all"; // 指定がないときはALL

  const [categoryKey, _setCategoryKey] =
    useState<keyof typeof evaluateCategoryHashWithAll>(categoryIdxInit);
  const onCategoryKeyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const key = e.target.value as keyof typeof evaluateCategoryHashWithAll;
    _setCategoryKey(key);
    key === "all" && _setEvalKey("all");
  };

  // ポジネガ
  const evalKeyInit = (searchParams.get("eval") ?? "all") as IPosNegKey;
  const [evalKey, _setEvalKey] = useState(evalKeyInit);
  const setEvalKey = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const key = e.target.value as IPosNegKey;
    _setEvalKey(key);
  };

  // const [page, setPage] = useState(1);

  const { data, isLoading, fetchNextPage } = useReviewsData({
    bId,
    category: categoryKey,
    evaluate: evalKey,
  });
  const pages = data?.pages ?? [];
  const reviews = pages.map((page) => page.reviews).flat();

  // クエリパラメータを設定
  useEffect(() => {
    setSearchParams({
      eval: evalKey,
      category: categoryKey,
    });
  }, [categoryKey, evalKey, setSearchParams]);

  return {
    reviews,
    evalKey,
    setEvalKey,
    categoryKey,
    onCategoryKeyChange,
    isLoading,
    existMore: pages[pages.length - 1]?.existMore,
    fetchNextPage,
  };
};

export default useReviewPage;
